module.exports = __webpack_public_path__ + "img/game-carousel-2.7d1f889b.png";